import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { ExploreSection } from '../../components/ExploreSection/ExploreSection';
import { Footer } from '../../components/Footer/Footer';
import { Spinner } from 'react-bootstrap';
export function HomePage({ appData }) {
  const [loading, setLoading] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [data, setData] = useState([])


  // Get tokens data
  useEffect(() => {
    const fetchData = async () => {
      // if data is already loaded, set the data and return
      if(appData.data.length > 0) {
        setData(appData.data)
        setLoaded(true)
        setLoading(false)
        return
      }
      setLoading(true)
      const data = await appData.getSharablesData()
      setData(data)
      setLoaded(true)
      setLoading(false)
    }
    if (!loaded && !loading) {
      fetchData()
    }
  }, [appData, loaded, loading])
  //
  return (
    <main
      style={{
        minHeight: '100vh',
        background: 'var(--theme-background, #ffffff)',
        color: 'var(--theme-text, #212529)',
        padding: '16px 0 100px',
      }}
    >
      <Container style={{ maxWidth: 1200, padding: '0 16px' }}>
        {data.length > 0 && !loading && <ExploreSection data={data} appData={appData} />}
        {/*Spinner center of the page*/}
        {loading && (
          <div style={{ 
            position: 'fixed', 
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)',
            zIndex: 1000
          }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}
      </Container>
      <Footer />
    </main>
  );
}

